import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';

const IMAGE_CACHE_TTL_MS = 5 * 60 * 1000;

type CacheEntry<T> = {
  expiresAt: number;
  value: T;
};

const imageCache = new Map<string, CacheEntry<any>>();
const inFlightImageRequests = new Map<string, Promise<any>>();

async function readThroughCache<T>(
  key: string,
  loader: () => Promise<T>,
): Promise<T> {
  const cached = imageCache.get(key);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.value;
  }

  const inFlight = inFlightImageRequests.get(key);
  if (inFlight) {
    return inFlight as Promise<T>;
  }

  const request = loader()
    .then(value => {
      imageCache.set(key, {
        value,
        expiresAt: Date.now() + IMAGE_CACHE_TTL_MS,
      });
      return value;
    })
    .finally(() => {
      inFlightImageRequests.delete(key);
    });

  inFlightImageRequests.set(key, request);
  return request;
}

export const getBase64ImageByUrl = async (url: string) => {
  return readThroughCache(`base64-image:${url}`, async () => {
    return fetchData(`${urls.getBase64Image}${url}`);
  });
};
